// extracted by mini-css-extract-plugin
module.exports = {"Tag__link":"f_Qx","Tag__inner":"ATAt","Tag__txt":"eFAV"};